export const SourcePlatformListColumns = [
  {
    title: "推广平台",
    width: 152,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "platformName",
    key: "platformName"
  },
  {
    title: "创建者",
    width: 96,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "creatorName",
    key: "creatorName"
  },
  {
    title: "创建日期",
    width: 128,
    ellipsis: true,
    align: "center",
    resizable: true,
    scopedSlots: { customRender: "insertTime" },
    key: "insertTime"
  },
  {
    title: "操作",
    align: "center",
    width: 120,
    className: "erp-table-operation-col",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
]

export const AllConversationListColumns = [
  {
    title: "沟通方式",
    width: 152,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "name",
    key: "name"
  },
  {
    title: "创建者",
    width: 96,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "creatorName",
    key: "creatorName"
  },
  {
    title: "创建日期",
    width: 128,
    ellipsis: true,
    align: "center",
    resizable: true,
    scopedSlots: { customRender: "insertTime" },
    key: "insertTime"
  },
  {
    title: "操作",
    align: "center",
    width: 120,
    className: "erp-table-operation-col",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
]

export const MarketingListColumns = [
  {
    title: "日期",
    width: 64,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "dateNo",
    scopedSlots: { customRender: "dateNo" },
    key: "dateNo"
  },
  {
    title: "消费",
    width: 40,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "cost",
    key: "cost"
  },
  {
    title: "展现数",
    width: 40,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "appearNum",
    key: "appearNum"
  },
  {
    title: "点击数",
    width: 40,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "clickNum",
    key: "clickNum"
  },
  {
    title: "抵达数",
    width: 40,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "arriveNum",
    key: "arriveNum"
  },
  {
    title: "总对话数",
    width: 48,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "conversationTotal",
    key: "conversationTotal"
  },
  {
    title: "有效对话数",
    width: 48,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "conversationValid",
    key: "conversationValid"
  },
  {
    title: "总对话率",
    width: 48,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "totalConversationRate" },
    key: "totalConversationRate"
  },
  {
    title: "有效对话率",
    width: 56,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "validConversationRate" },
    key: "validConversationRate"
  },
  {
    title: "抵达率",
    width: 40,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "arriveRate" },
    key: "arriveRate"
  },
  {
    title: "点击率",
    width: 40,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "clickRate" },
    key: "clickRate"
  },
  {
    title: "点击成本",
    width: 48,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "clickCost" },
    key: "clickCost"
  },
  {
    title: "总对话成本",
    width: 48,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "totalConversationCost" },
    key: "totalConversationCost"
  },
  {
    title: "有效对话成本",
    width: 56,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "validConversationCost" },
    key: "validConversationCost"
  },
  {
    title: "创建日期",
    width: 96,
    ellipsis: true,
    align: "center",
    resizable: true,
    scopedSlots: { customRender: "insertTime" },
    key: "insertTime"
  },
  {
    title: "操作",
    fixed: "right",
    align: "center",
    width: 120,
    className: "erp-table-operation-col",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
]

export const SourcePlatformMarketingListColumns = [
  {
    title: "日期",
    width: 88,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "dateNo",
    // scopedSlots: { customRender: "dateNo" },
    key: "dateNo"
  },
  {
    title: "平台名",
    width: 96,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "dateNo",
    scopedSlots: { customRender: "sourcePlatformID" },
    key: "sourcePlatformID"
  },
  {
    title: "消费",
    width: 40,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "cost",
    key: "cost"
  },
  {
    title: "展现数",
    width: 48,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "appearNum",
    key: "appearNum"
  },
  {
    title: "点击数",
    width: 48,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "clickNum",
    key: "clickNum"
  },
  {
    title: "抵达数",
    width: 48,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "arriveNum",
    key: "arriveNum"
  },
  {
    title: "总对话数",
    width: 56,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "conversationTotal",
    key: "conversationTotal"
  },
  {
    title: "有效对话数",
    width: 64,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "conversationValid",
    key: "conversationValid"
  },
  {
    title: "总对话率",
    width: 72,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "totalConversationRate" },
    key: "totalConversationRate"
  },
  {
    title: "有效对话率",
    width: 72,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "validConversationRate" },
    key: "validConversationRate"
  },
  {
    title: "抵达率",
    width: 72,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "arriveRate" },
    key: "arriveRate"
  },
  {
    title: "点击率",
    width: 72,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "clickRate" },
    key: "clickRate"
  },
  {
    title: "点击成本",
    width: 72,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "clickCost" },
    key: "clickCost"
  },
  {
    title: "总对话成本",
    width: 72,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "totalConversationCost" },
    key: "totalConversationCost"
  },
  {
    title: "有效对话成本",
    width: 72,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "cost",
    scopedSlots: { customRender: "validConversationCost" },
    key: "validConversationCost"
  },
  {
    title: "创建日期",
    width: 128,
    ellipsis: true,
    align: "center",
    resizable: true,
    scopedSlots: { customRender: "insertTime" },
    key: "insertTime"
  },
  {
    title: "操作",
    fixed: "right",
    align: "center",
    width: 120,
    className: "erp-table-operation-col",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
]

export const SourcePlatformMarketingConversationListColumns = [
  {
    title: "沟通方式",
    width: 240,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "name",
    // scopedSlots: { customRender: "dateNo" },
    key: "name"
  },
  {
    title: "沟通次数",
    width: 160,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "dateNo",
    scopedSlots: { customRender: "conversationNum" },
    key: "conversationNum"
  }
]
